Toutou_Fonts = function() {
    if (gfonte == 0) {
        if (window.devicePixelRatio == 1) {
            this.filigrane_petit = "100px Times New Roman";
            this.filigrane = "140px Times New Roman";
            this.filigrane_gros = "400px Times New Roman";
            this.principal = "24px Times New Roman";
            this.axis = "18px Times New Roman";
            this.legende = "18px Times New Roman";
            this.hover = "18px Times New Roman";
            this.hover_pixel = 18;
        } else {
            this.filigrane_petit = "50px Times New Roman";
            this.filigrane = "70px Times New Roman";
            this.filigrane_gros = "200px Times New Roman";
            this.principal = "12px Times New Roman";
            this.axis = "9px Times New Roman";
            this.legende = "9px Times New Roman";
            this.hover = "9px Times New Roman";
            this.hover_pixel = 9;
        }
    } else if (gfonte == 1) {
        if (window.devicePixelRatio == 1) {
            this.filigrane_petit = "100px Times New Roman";
            this.filigrane = "140px Times New Roman";
            this.filigrane_gros = "400px Times New Roman";
            this.principal = "30px Times New Roman";
            this.axis = "20px Times New Roman";
            this.legende = "20px Times New Roman";
            this.hover = "20px Times New Roman";
            this.hover_pixel = 20;
        } else {
            this.filigrane_petit = "50px Times New Roman";
            this.filigrane = "70px Times New Roman";
            this.filigrane_gros = "200px Times New Roman";
            this.principal = "15px Times New Roman";
            this.axis = "10px Times New Roman";
            this.legende = "10px Times New Roman";
            this.hover = "10px Times New Roman";
            this.hover_pixel = 10;
        }
    } else if (gfonte == 2) {
        if (window.devicePixelRatio == 1) {
            this.filigrane_petit = "80px Times New Roman";
            this.filigrane = "120px Times New Roman";
            this.filigrane_gros = "400px Times New Roman";
            this.principal = "40px Times New Roman";
            this.axis = "30px Times New Roman";
            this.legende = "30px Times New Roman";
            this.hover = "30px Times New Roman";
            this.hover_pixel = 30;
        } else {
            this.filigrane_petit = "40px Times New Roman";
            this.filigrane = "60px Times New Roman";
            this.filigrane_gros = "200px Times New Roman";
            this.principal = "20px Times New Roman";
            this.axis = "15px Times New Roman";
            this.legende = "15px Times New Roman";
            this.hover = "15px Times New Roman";
            this.hover_pixel = 15;
        }
    } else if (gfonte == 3) {
        if (window.devicePixelRatio == 1) {
            this.filigrane_petit = "100px Times New Roman";
            this.filigrane = "140px Times New Roman";
            this.filigrane_gros = "400px Times New Roman";
            this.principal = "50px Times New Roman";
            this.axis = "35px Times New Roman";
            this.legende = "35px Times New Roman";
            this.hover = "35px Times New Roman";
            this.hover_pixel = 35;
        } else {
            this.filigrane_petit = "50px Times New Roman";
            this.filigrane = "70px Times New Roman";
            this.filigrane_gros = "200px Times New Roman";
            this.principal = "25px Times New Roman";
            this.axis = "17px Times New Roman";
            this.legende = "17px Times New Roman";
            this.hover = "17px Times New Roman";
            this.hover_pixel = 17;
        }
    }
};

//# sourceMappingURL=imeteo.a0ae009a.js.map
